import { render, staticRenderFns } from "./HubSlider.vue?vue&type=template&id=39b8eeeb&scoped=true&"
import script from "./HubSlider.vue?vue&type=script&lang=ts&"
export * from "./HubSlider.vue?vue&type=script&lang=ts&"
import style0 from "./HubSlider.vue?vue&type=style&index=0&id=39b8eeeb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8eeeb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
